import {
	diaryByIdQueryOptions,
	useDiaryByIdQuery,
} from "@/features/diaries/api";
import { extractEventById } from "@/features/diaries/services/extractEventById";
import EditEvent from "@/features/events/components/EditEvent";
import {
	diariesBreadcrumb,
	editBreadcrumb,
} from "@/features/navigation/services/breadcrumbRoutes";
import { hooks as h } from "@/hooks";
import { createFileRoute } from "@tanstack/react-router";
const EditEventPage = () => {
	const { diaryId, eventId } = Route.useParams();
	const { data: diary } = useDiaryByIdQuery(diaryId);
	const event = extractEventById(diary, eventId);

	h.useNav([diariesBreadcrumb, editBreadcrumb]);

	return <EditEvent event={event} />;
};

export const Route = createFileRoute(
	"/_app/diaries/$diaryId/edit/event/$eventId/",
)({
	component: EditEventPage,
	loader: async ({ context, params }) => {
		await context?.queryClient.ensureQueryData(
			diaryByIdQueryOptions(params.diaryId),
		);
	},
});
